module.exports = __webpack_public_path__ + "static/media/WTM_10_13_Nov.ef61b598.gif";